import { View, StyleSheet } from 'react-native';

import { colors, spacing } from '../../../theme';
import { LockIcon } from '../../../assets';

interface Props {
	status?: 'primary' | 'danger';
}

const ICON_SIZE = 24;
const ICON_STROKE_COLORS = {
	primary: colors.primary700,
	danger: colors.danger800,
};
const BACKGROUND_COLORS = {
	primary: colors.primary100,
	danger: colors.danger100,
};

export const Lock = ({ status = 'primary' }: Props) => {
	return (
		<View style={[styles.root, { backgroundColor: BACKGROUND_COLORS[status] }]}>
			<LockIcon width={ICON_SIZE} height={ICON_SIZE} color={ICON_STROKE_COLORS[status]} />
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		borderRadius: 4,
		padding: spacing(),
		aspectRatio: 1,
		height: ICON_SIZE + 2 * spacing(),
		justifyContent: 'center',
		alignItems: 'center',
	},
});
